import { useNavigate } from "react-router-dom";
import { HeartHandshake, Users, Sparkles, Heart, Leaf, Flower2, ArrowRight, Phone, CalendarDays, ChevronRight } from "lucide-react";

const SERVICES = [
  { key: "professional", label: "Talk to a Professional", to: "/mental-wellness/consultants", bg: "#EDE4FB", color: "#7C3AED", Icon: HeartHandshake },
  { key: "family", label: "Relationship & Family Support", to: "/mental-wellness/consultants", bg: "#FCE7EF", color: "#EC4899", Icon: Users },
  { key: "personality", label: "Personality Development", to: "/mental-wellness/consultants", bg: "#EDE4FB", color: "#6D28D9", Icon: Sparkles },
  { key: "mood", label: "Mood Check-In", to: "/mental-wellness/mood-tracker", bg: "#FCE7EF", color: "#EC4899", Icon: Heart },
  { key: "self-care", label: "Guided Self-Care", to: "/mental-wellness/mindfulness", bg: "#E7F6EC", color: "#16A34A", Icon: Leaf },
  { key: "retreats", label: "Offline Wellness Retreats", to: "/mental-wellness/retreats", bg: "#E7F6EC", color: "#16A34A", Icon: Flower2 },
];

export default function MentalWellness() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold" style={{ color: "#2E1065" }}>Mental Wellness</h1>
          <p className="text-muted-foreground mt-1">A healthier mind for a happier you. Confidential, personalised, professional.</p>
        </div>
        <button onClick={() => navigate("/mental-wellness/my-sessions")} data-testid="mw-my-sessions" className="shrink-0 flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold" style={{ background: "#F3EEFC", color: "#7C3AED" }}>
          <CalendarDays className="h-4 w-4" /> My Sessions
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {SERVICES.map((s) => (
          <button key={s.key} onClick={() => navigate(s.to)} data-testid={`mw-service-${s.key}`} className="rounded-2xl border bg-white p-5 text-left hover:shadow-md hover:-translate-y-0.5 transition-all" style={{ borderColor: "#EDE7F8" }}>
            <div className="h-12 w-12 rounded-2xl flex items-center justify-center" style={{ background: s.bg }}>
              <s.Icon className="h-6 w-6" style={{ color: s.color }} />
            </div>
            <p className="mt-3 font-semibold text-sm" style={{ color: "#44375F" }}>{s.label}</p>
          </button>
        ))}
      </div>

      <button onClick={() => navigate("/mental-wellness/care-comfort")} data-testid="mw-care-comfort" className="w-full rounded-2xl p-5 flex items-center gap-4 text-left" style={{ background: "linear-gradient(135deg,#0F766E,#115E59)" }}>
        <div className="h-12 w-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: "rgba(255,255,255,0.14)" }}>
          <HeartHandshake className="h-6 w-6" style={{ color: "#CCFBF1" }} />
        </div>
        <div className="flex-1">
          <p className="font-bold text-white">Care & Comfort Support</p>
          <p className="text-sm mt-1" style={{ color: "#CCFBF1" }}>Living with cancer or a serious illness? Connect with specialised professionals and a peer community that understands.</p>
        </div>
        <ChevronRight className="h-5 w-5 shrink-0" style={{ color: "#99F6E4" }} />
      </button>

      <button onClick={() => navigate("/mental-wellness/find-support")} data-testid="mw-start-checkin" className="w-full rounded-2xl border p-5 flex items-center gap-4 text-left" style={{ background: "#F3EEFC", borderColor: "#E7DEF8" }}>
        <div className="flex-1">
          <p className="font-semibold" style={{ color: "#2E1065" }}>Not sure where to start?</p>
          <p className="text-sm mt-1" style={{ color: "#6B5B8A" }}>Take a 2-minute wellness check-in and get personalised recommendations.</p>
        </div>
        <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "#7C3AED" }}><ArrowRight className="h-5 w-5 text-white" /></div>
      </button>

      <button onClick={() => navigate("/mental-wellness/helplines")} data-testid="mw-emergency" className="w-full rounded-2xl border bg-white p-5 flex items-center gap-4 text-left" style={{ borderColor: "#FADADD" }}>
        <div className="h-10 w-10 rounded-full flex items-center justify-center shrink-0" style={{ background: "#FEE2E2" }}><Phone className="h-5 w-5" style={{ color: "#DC2626" }} /></div>
        <div className="flex-1">
          <p className="font-semibold" style={{ color: "#1F1147" }}>Emergency support</p>
          <p className="text-sm mt-0.5" style={{ color: "#8B7CA6" }}>If you or someone you know is in immediate distress.</p>
        </div>
        <ChevronRight className="h-5 w-5 shrink-0" style={{ color: "#DC2626" }} />
      </button>
    </div>
  );
}
